export const IBillingSessionAmount = Object.freeze({
  totalTTCLegacy: "total_amount_t_t_c",
  totalHT: "total_amount_h_t",
  totalTax: "total_amount_tax",
  includingTaxTotal: "amount_ttc",
  excludingTaxTotal: "amount_ht",
});

export class BillingSessionAmountModel {
  constructor(data = {}) {
    this[IBillingSessionAmount.totalTTCLegacy] = data[IBillingSessionAmount.totalTTCLegacy];
    this[IBillingSessionAmount.totalHT] = data[IBillingSessionAmount.totalHT];
    this[IBillingSessionAmount.totalTax] = data[IBillingSessionAmount.totalTax];
    this[IBillingSessionAmount.includingTaxTotal] = data[IBillingSessionAmount.includingTaxTotal];
    this[IBillingSessionAmount.excludingTaxTotal] = data[IBillingSessionAmount.excludingTaxTotal];

  }

  hasTotal() {
    return this.getTotalTTC() > 0;
  }

  getTotalTTC() {
    return this[IBillingSessionAmount.totalTTCLegacy];
  }

  getTotalHT() {
    return this[IBillingSessionAmount.totalHT];
  }

  getTotalTax() {
    return this[IBillingSessionAmount.totalTax];
  }

  getIncludingTaxTotal() {
    return this[IBillingSessionAmount.includingTaxTotal];
  }

  getExcludingTaxTotal() {
    return this[IBillingSessionAmount.excludingTaxTotal];
  }
}
